import styles from '../sizeChart.module.scss'
import Toggle from '../../toggle'
import React from 'react'
import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

interface SizeChartUnitsToggleProps {
  sizeChartSections: ContentfulSizeChartSection[]
  isUnitsToggleActive: boolean
  onUnitsToggle: () => void
}

const getSizeChartUnitsToggleData = (sizeChartSections: ContentfulSizeChartSection[]) => {
  return {
    leftSideText: sizeChartSections[0].title,
    rightSideText: sizeChartSections[1].title,
  }
}

const SizeChartUnitsToggle = (props: SizeChartUnitsToggleProps) => {
  const { leftSideText, rightSideText } = getSizeChartUnitsToggleData(props.sizeChartSections)
  return (
    <div className={styles.container__header__toggle}>
      <span className={styles.container__header__text}>{leftSideText.toUpperCase()}</span>
      <Toggle
        active={props.isUnitsToggleActive}
        onToggle={props.onUnitsToggle}
        className={styles.container__header__toggle__icon}
      />
      <span className={styles.container__header__text}>{rightSideText.toUpperCase()}</span>
    </div>
  )
}

export default SizeChartUnitsToggle
